import React, { useState, useEffect } from 'react'
import axios, { AxiosResponse } from 'axios';
import { useHistory, useLocation } from 'react-router-dom';
import logoUDD from '../../../../assets/svg/logo-udd-blanco.svg';
import wp from '../../../../assets/svg/logo-webpay.svg';
import { Autocomplete } from '@material-ui/lab'
import { CardActionArea, CardActions, List, ListItem, ListItemText, LinearProgress } from '@material-ui/core';
import { IniciarMandatoPatLogic, ValidarMandatoPatLogic, ObtenerBancosGPALogic, IniciarMandatoPacLogic, TieneMandatoPacLogic, TieneMandatoPatLogic, ObtenerDatosAlumnoLogic, ObtieneComprobanteLogic, InsertarMandatoPatLogic } from '../../../view-model/PACPAT/PacPat.logic';
/* import $ from 'jquery'; */
import { Button, Dialog, DialogActions, TextField, CircularProgress, Grid, CardContent, Card, DialogContent, DialogTitle, Checkbox, InputLabel, Paper, PaperProps } from '@material-ui/core'
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline'
import queryString from 'query-string';
import IViewPacPat from '../../../view-interfaces/IViewPacPat'
import IViewCombo from '../../../view-interfaces/IViewCombo'
import IViewPostulaciones from '../../../view-interfaces/IViewPostulaciones';
import IViewPostulante from '../../../view-interfaces/IViewPostulante';
import ErrorOutlineRounded from '@material-ui/icons/ErrorOutlineRounded'
//import { ObtieneDatosPostulanteLogic, useStyles } from '../../../view-model/Inicio/InicioEstudiante.logic';
import { useStyles } from '../../../view-model/Inicio/InicioEstudiante.logic';
import { ObtienePostulacionesLogic } from '../../../view-model/Inicio/PostulacionesEstudiante.logic';
import toUpperCamelCase from '../../../view-model/Funciones/toUpperCamelCase'
import { Alert } from '@material-ui/lab';
import { data } from 'jquery';
import MensajeToken from '../../../../Components/MensajeToken/MensajeToken';
const { validarRUT } = require('validar-rut')
const { formatterRut, cleanRut } = require('chilean-formatter')
type Props = {
}
export const PacPat: React.FC<Props> = () => {
    const history = useHistory();
    const location = useLocation();
    const [estiloRut, setEstiloRut] = useState('form-control js-rut js-will-validate');
    const [rutCompletoAlumno, setRutCompletoAlumno] = useState('')
    const [rutAlumno, setRutAlumno] = useState(0)
    const [dvAlumno, setDvRutAlumno] = useState('')
    const [nombreAlumno, setNombreAlumno] = useState('')
    const [mailAlumno, setMailAlumno] = useState('')
    const [telefonoAlumno, setTelefonoAlumno] = useState('')
    const [anoproc, setanoproc] = useState(0)
    const [codnegocio, setcodnegocio] = useState(0)
    const [codplanacad, setcodplanacad] = useState(0)
    const [codprograma, setcodprograma] = useState('')
    const [sede, setsede] = useState('')
    const [semestreproc, setsemestreproc] = useState(0)
    const [tipomandato, settipomandato] = useState('')

    const [url, setUrl] = useState('')
    const [token, setToken] = useState('')

    const [openModalRespuesta, setOpenModalRespuesta] = useState(false)

    const [resultPAT, setResultPAT] = useState(false)
    const [resultPAC, setResultPAC] = useState('')

    const [listo, setListo] = useState(false)

    const [procesoIniciado, setProcesoIniciado] = useState(false)

    const listaBancos: Array<IViewCombo> = [];
    const [bancos, setBancos] = useState(listaBancos);

    //Datos Formulario PAC
    const [rutCompletoPAC, setRutCompletoPAC] = useState('')
    const [rutPAC, setRutPAC] = useState(0)
    const [dvPAC, setDvPAC] = useState("")
    const [nombresPAC, setNombresPAC] = useState('')
    const [primerApellidoPAC, setPrimerApellidoPAC] = useState('')
    const [segundoApellidoPAC, setSegundoApellidoPAC] = useState('')
    const [direccionPAC, setDireccionPAC] = useState('')
    const [telefonoPAC, setTelefonoPAC] = useState('')
    const [correoPAC, setCorreoPAC] = useState('')

    const [idCarreraPAC, setIdCarreraPAC] = useState('')
    const [nombreCarreraPAC, setNombreCarreraPAC] = useState('')

    const _banco: IViewCombo = { ID: 0, descripcion: '' };
    const [valBancoPAC, setValBancoPAC] = useState(_banco)
    const [idBancoPAC, setIdBancoPAC] = useState(0)

    const [numCuentaPAC, setNumCuentaPAC] = useState('')
    const [diaCargoPAC, setDiaCargoPAC] = useState(0)
    const [observacionPAC, setObservacionPAC] = useState('')

    const [guardado, setGuardado] = useState(false)

    const [errorVal, setError] = useState('');
    const [mnsjError, setMnsjError] = useState('');

    const [alumno, setAlumno] = useState({});

    const [tieneMandatoPAC, setTieneMandatoPAC] = useState(false)

    const [cargandoValores, setCargandoValores] = useState(true)
    const [downloadComprobante, setDownloadComprobante] = useState(false)

    const [errorPAT, setErrorPAT] = useState(false)
    const [openModalToken, setOpenModalToken] = useState({ open: false, mnsj: "" })
    useEffect(() => {
        let url = window.location.href;
        if (url.indexOf('?') !== -1) {
            var alumno = queryString.parse(window.location.search);
            /* console.log(alumno) */
            setRutAlumno(parseInt(alumno.rut!.toString()))
            setcodnegocio(parseInt(alumno.codnegocio!.toString()));
            setcodprograma(alumno.codprograma!.toString());
            //setcodplanacad(parseInt(alumno.codplanacad!.toString()));
            setanoproc(parseInt(alumno.anoproc!.toString()));
            setsemestreproc(parseInt(alumno.semestreproc!.toString()));
            settipomandato(alumno.tipomandato!.toString());
            setIdCarreraPAC(alumno.codprograma!.toString())
            setsede(alumno.sede!.toString())
            if (alumno.tipomandato!.toString() === "PAC") {
                TieneMandatoPacLogic(selTieneMandatoPac, alumno.codprograma!.toString(), parseInt(alumno.rut!.toString()), 2, 1)
            } else {
                TieneMandatoPatLogic(selTieneMandatoPat, alumno.codprograma!.toString(), parseInt(alumno.rut!.toString()), 1, 1)
            }
            /* ObtienePostulacionesLogic(selListaPostulaciones, parseInt(alumno.rut!.toString()), 0, 0, 0); */
        } else {
            history.push({
                pathname: "/Inicio"
            });
        }
    }, [])
    const selTieneMandatoPac = (error: Boolean, err: string, data: any) => {
        try {
            if (error === false) {
                setTieneMandatoPAC(data)
            } else {
            }
        } catch (err) {
            console.log('error', err)
        }
    }
    const selTieneMandatoPat = (error: Boolean, err: string, data: any) => {
        try {
            if (error === false) {
                setListo(data)
                setProcesoIniciado(false)
            } else {
                setListo(false)
                setProcesoIniciado(false)
            }
        } catch (err) {
            console.log('error', err)
        }
    }
    useEffect(() => {
        if (rutAlumno !== 0) {
            let _tt = JSON.stringify(location.state);
            let _params = JSON.parse(_tt);
            setTimeout(() => {
                ObtienePostulacionesLogic(selListaPostulaciones, _params.headers, rutAlumno, 0, 0, 1);
                ObtenerDatosAlumnoLogic(selListaPostulante, rutAlumno, codprograma, true)
            }, 3000)
        }
    }, [rutAlumno])

    useEffect(() => {
        if (tipomandato === "PAC") {
            ObtenerBancosGPALogic(selListaBancos)
        } else if (tipomandato === "PAT") {
        }
    }, [tipomandato])

    const selListaBancos = (error: Boolean, err: string, result: IViewCombo[]) => {
        try {
            if (error === false) {
                /* console.log(result) */
                setBancos(result)
            }
            else {
            }
        } catch (error) {
        }
    }

    const IniciarMandato = () => {
        setProcesoIniciado(true)
        if (tipomandato === "PAT") {
            IniciarMandatoPatLogic(selIniciarMandatoPat, rutAlumno, codnegocio, codprograma, codplanacad, anoproc)
        }
    }


    const selListaPostulaciones = (error: Boolean, err: string, Postulaciones: IViewPostulaciones[]) => {
        if (error === false && Postulaciones !== undefined) {
            /* console.log(Postulaciones) */

            Postulaciones.map((e: IViewPostulaciones) => {
                if (e.codCarrera === idCarreraPAC) {
                    setNombreCarreraPAC(e.nombreCarrera)
                }
            })
        } else {
            if (err != "500") {
                setOpenModalToken({ open: true, mnsj: err })
            }
        }
    }

    const selListaPostulante = (error: Boolean, err: string, Estudiante: any) => {
        try {
            if (error === false) {
                /* console.log(Estudiante) */
                /* let _alumno: any = []; */
                setRutCompletoAlumno(Estudiante.rutCompleto)
                setRutAlumno(Estudiante.rut)
                setDvRutAlumno(Estudiante.dv)
                setNombreAlumno(Estudiante.nombreCompleto)
                setMailAlumno(Estudiante.mail)
                setTelefonoAlumno(Estudiante.telefono)
                setDiaCargoPAC(Estudiante.diaPago)
                /* _alumno.push({
                    Rut: Estudiante[0].rut,
                    Dv: Estudiante[0].dv,
                    Nombres: Estudiante[0].nombre,
                    ApellidoPat: Estudiante[0].apellidoPaterno,
                    ApellidoMat: Estudiante[0].apellidoMaterno,
                    Direccion: Estudiante[0].direccion,
                    Telefono: 99999999,
                    Correo: Estudiante[0].correoUDD
                }) */
                setAlumno({
                    Rut: Estudiante.rut,
                    Dv: Estudiante.dv,
                    Nombres: Estudiante.nombres,
                    ApellidoPat: Estudiante.apMaterno,
                    ApellidoMat: Estudiante.apPaterno,
                    Direccion: Estudiante.direccion,
                    Telefono: Estudiante.telefono,
                    Correo: Estudiante.mail
                })
            }
            else {
            }
            setCargandoValores(false)
        } catch (error) {
        }
    }

    const selIniciarMandatoPat = (error: Boolean, err: string, data: any) => {
        try {
            if (error === false) {
                /* console.log(data) */
                setUrl(`${data.url}`)
                setToken(`${data.token}`)
                if (data.url.length > 0 && data.token.length > 0) {

                    let windowName = 'w_' + Date.now() + Math.floor(Math.random() * 100000).toString();
                    var form = document.createElement("form");
                    form.setAttribute("method", "post");
                    form.setAttribute("action", data.url);

                    form.setAttribute("target", windowName);

                    var hiddenField = document.createElement("input");
                    hiddenField.setAttribute("type", "hidden");
                    hiddenField.setAttribute("name", "tokenComercio");
                    hiddenField.setAttribute("value", data.token);
                    form.appendChild(hiddenField);
                    document.body.appendChild(form);

                    var respuesta = window.open('', windowName);

                    insertarMandatoPAT(data.token);

                    var timer = setInterval(function () {
                        try {
                            if (respuesta!.closed) {
                                ValidarMandatoPatLogic(selValidarMandatoPat, data.token, rutAlumno, codprograma)
                                clearInterval(timer);
                            }
                        } catch {

                        }
                    }, 500);
                    form.submit();
                    setErrorPAT(false)
                } else {
                    setErrorPAT(true)
                    setProcesoIniciado(false)
                }
            } else {
                setErrorPAT(true)
                setProcesoIniciado(false)
            }
        } catch (err) {
            console.log('error', err)
        }
    }
    const selValidarMandatoPat = (error: Boolean, err: string, data: any) => {
        try {
            if (error === false) {
                /* console.log(data) */
                setResultPAT(data)
                if (!data)
                    setOpenModalRespuesta(true)
            } else {
                setResultPAT(false)
                setOpenModalRespuesta(true)
            }
            setProcesoIniciado(false)
        } catch (err) {
            console.log('error', err)
        }
    }

    const handleValidarDatos = () => {
        let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        //var today = new Date();
        try {
            if (rutCompletoPAC === "" || rutCompletoPAC === undefined) {
                setError("true");
                setMnsjError("Debe ingresar RUT.");
            } else if ((nombresPAC === "" || nombresPAC === undefined)) {
                setError("true");
                setMnsjError("Debe ingresar Nombre.");
            } else if ((primerApellidoPAC === "" || primerApellidoPAC === undefined)) {
                setError("true");
                setMnsjError("Debe ingresar primer apellido.");
            } else if ((segundoApellidoPAC === "" || segundoApellidoPAC === undefined)) {
                setError("true");
                setMnsjError("Debe ingresar segundo apellido.");
            } else if ((direccionPAC === "" || direccionPAC === undefined)) {
                setError("true");
                setMnsjError("Debe ingresar dirección.");
            } else if (telefonoPAC === "" || telefonoPAC === "0" || telefonoPAC === undefined) {
                setError("true");
                setMnsjError("Debe ingresar teléfono.");
            } else if (telefonoPAC.length !== 9) {
                setError("true");
                setMnsjError("Debe ingresar teléfono correctamente.");
            } else if (correoPAC === "" || correoPAC === undefined) {
                setError("true");
                setMnsjError("Debe ingresar Email.");
            } else if (!regEmail.test(correoPAC)) {
                setError("true");
                setMnsjError("Debe ingresar Email válido.");
            } else if (idBancoPAC === 0) {
                setError("true");
                setMnsjError("Debe seleccionar banco.");
            } else if (numCuentaPAC === "" || numCuentaPAC === "0" || numCuentaPAC === undefined) {
                setError("true");
                setMnsjError("Debe ingresar número de cuenta válido.");
            } else {
                setError("false");
            }
        } catch (e: any) {
            setError("true");
            setMnsjError("Ocurrio un error al validar sus datos.");
        }
    }
    useEffect(() => {

        if (errorVal === "false") {
            let _apoderado: any = {
                Rut: rutPAC,
                Dv: dvPAC,
                Nombres: nombresPAC,
                ApellidoPat: primerApellidoPAC,
                ApellidoMat: segundoApellidoPAC,
                Direccion: direccionPAC,
                Telefono: telefonoPAC,
                Correo: correoPAC
            };
            /* _apoderado.push({
                Rut: rutPAC,
                Dv: dvPAC,
                Nombres: nombresPAC,
                ApellidoPat: primerApellidoPAC,
                ApellidoMat: segundoApellidoPAC,
                Direccion: direccionPAC,
                Telefono: telefonoPAC,
                Correo: correoPAC
            }) */
            let _mandato: any = {
                IdMandato: 0,
                IdBanco: idBancoPAC,
                IdConvenio: 0,
                CodInterno: 0,
                CodCarrera: codprograma,
                RutAlumno: rutAlumno,
                RutApoderado: rutPAC,
                IdServicio: rutAlumno.toString() + "" + dvAlumno.toString(),
                NumCuentaCorriente: numCuentaPAC,
                DiaPago: diaCargoPAC,
                Sincronizado: true,
                Inconsistencia: false,
                Diferencia: false,
                Sede: sede,
            };
            let _data: any = {
                tipoMandato: 2,
                tipoOrigen: 1,
                mandato: _mandato,
                Alumno: alumno,
                Apoderado: _apoderado
            };
            /* _data.push({
                mandato:_mandato,
                Alumno: alumno,
                Apoderado: _apoderado
            }) */
            IniciarMandatoPacLogic(selIniciarMandatoPac, _data)
            /* console.log(_data) */
        }
    }, [errorVal])

    const insertarMandatoPAT = (token: string) => {
        let _mandato: any = {
            IdMandato: 0,
            IdBanco: 1,
            IdConvenio: 0,
            CodInterno: 0,
            CodCarrera: codprograma,
            RutAlumno: rutAlumno,
            RutApoderado: rutAlumno,
            IdServicio: rutAlumno.toString() + "" + dvAlumno.toString(),
            NumCuentaCorriente: token,
            DiaPago: diaCargoPAC,
            Sincronizado: true,
            Inconsistencia: false,
            Diferencia: false,
            Sede: sede,
        };
        let _data: any = {
            tipoMandato: 2,
            tipoOrigen: 1,
            mandato: _mandato,
            Alumno: alumno,
            Apoderado: alumno
        };
        InsertarMandatoPatLogic(selInsertarMandatoPat, _data)
        /* console.log(_data) */

    }

    const selIniciarMandatoPac = (error: Boolean, err: string, data: any) => {
        try {
            if (error === false) {
                setResultPAC(data.toString())
            } else {
                setResultPAC("false")
            }
        } catch (err) {
            console.log('error', err)
            setResultPAC("false")
        }
    }
    const selInsertarMandatoPat = (error: Boolean, err: string, data: any) => {
        try {
            if (error === false) {
                setResultPAT(data.toString())
            } else {
                setResultPAC("false")
            }
        } catch (err) {
            console.log('error', err)
        }
    }
    useEffect(() => {
        if (rutCompletoPAC.trim().length > 6) {
            if (validarRUT(rutCompletoPAC.trim())) {
                setRutCompletoPAC(formatterRut(rutCompletoPAC.trim()));
                setEstiloRut("form-control js-rut js-will-validate is-valid");

                setRutPAC(cleanRut(rutCompletoPAC, false))
                setDvPAC(formatterRut(rutCompletoPAC).split('-')[1])
                setError("");
                setMnsjError("");
            } else {
                setEstiloRut("form-control js-rut js-will-validate is-invalid")
                setError("true");
                setMnsjError("Debe ingresar un rut válido.");
            }
        }
    }, [rutCompletoPAC])
    const handleSelectBanco = (event: any, newValue: any) => {
        if (newValue !== null) {
            setIdBancoPAC(newValue.ID);
            setValBancoPAC(newValue);
        }
    }
    const obtenerComprobante = () => {
        setDownloadComprobante(true)
        ObtieneComprobanteLogic(selObtenerComprobante, codprograma, rutAlumno, (tipomandato === "PAC" ? 2 : 1), 1)
    }
    const selObtenerComprobante = (error: Boolean, err: string, data: any) => {
        try {
            setDownloadComprobante(false)
        } catch (err) {
            console.log('error', err)
        }
    }
    return (
        <>
            {
                cargandoValores ?
                    <div className="site-main__container">
                        <div style={{ textAlign: 'center', marginTop: 100 }}>

                            <CircularProgress disableShrink />
                            <br />
                            <a><span>Cargando datos.</span></a>

                        </div>
                    </div>
                    :
                    <>
                        <header style={{ position: 'fixed', display: 'grid', zIndex: 99 }} className="site-header">
                            <div className="site-header__container2">
                                <div style={{ display: 'flex' }}>
                                    <div>
                                        <img style={{ marginLeft: '2rem', marginTop: '1rem' }} src={logoUDD} alt="Logo Universidad de Desarrollo" className="site-header__logo" />
                                    </div>
                                </div>
                            </div>
                        </header>

                        <br></br>
                        <br></br>
                        <br></br>
                        <main className="site-main enrollment">
                            <div className="site-main__container">
                                <div className="enrollment__title" >Mandato {tipomandato}</div>
                                {/* <p style={{ border: "1px solid", width: "100%", padding: 20 }}>
                                        <div style={{ fontSize: 15 }} className="enrollment__subtitle">Titular:</div>
                                        <br />
                                        <p className="enrollment__subtitle">Rut: {rutAlumno}</p>
                                        <br />
                                        <p className="enrollment__subtitle">Nombre Completo: {nombreAlumno}</p>
                                        <br />
                                    </p> */}
                                <p style={{ border: "2px double #1C6EA4", borderRadius: '10px 10px 10px 10px' }}>
                                    <Grid container item xs={12} sm={12} md={12} direction="column" alignItems="stretch">
                                        <p style={{ fontSize: 19, marginTop: 18, marginLeft: 31 }}>Datos Alumno</p>
                                        <Card elevation={0}>
                                            <CardContent>
                                                <Grid container direction="row" alignItems="stretch"  >
                                                    <Grid item xs={12} sm={6} md={6}>
                                                        <div style={{ marginTop: -18 }}>
                                                            <List dense >
                                                                <ListItem >
                                                                    <p>
                                                                        <p style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: 12 }}>Rut</p>
                                                                        <p style={{ marginTop: -15, fontSize: 15 }}>{rutCompletoAlumno}</p>
                                                                    </p>
                                                                </ListItem>
                                                                <ListItem >
                                                                    <p>
                                                                        <p style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: 12 }}>Nombres</p>
                                                                        <p style={{ marginTop: -15, fontSize: 15, marginBottom: -20 }}>{nombreAlumno}</p>
                                                                    </p>
                                                                </ListItem>
                                                            </List>
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={6}>
                                                        <div style={{ marginTop: -18 }}>
                                                            <List dense >
                                                                <ListItem >
                                                                    <p >
                                                                        <p style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: 12 }}>Teléfono</p>
                                                                        <p style={{ marginTop: -15, fontSize: 15 }}>{telefonoAlumno}</p>
                                                                    </p>
                                                                </ListItem>
                                                                <ListItem >
                                                                    <p >
                                                                        <p style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: 12 }}>E-mail</p>
                                                                        <p style={{ marginTop: -15, fontSize: 15, marginBottom: -20 }}>{mailAlumno}</p>
                                                                    </p>
                                                                </ListItem>
                                                            </List>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                </p>
                                <div className="">
                                    <div className="payment-webpay__enrollment">
                                        <div style={{ textAlign: 'center', padding: 20 }}>
                                            {
                                                tipomandato === "PAC" ?
                                                    tieneMandatoPAC ?
                                                        <p><CheckCircleOutline style={{ fontSize: 50, color: '#0062a1' }} /> Usted ya tiene este proceso listo</p>
                                                        :
                                                        resultPAC === "true" ?
                                                            <p><CheckCircleOutline style={{ fontSize: 50, color: '#0062a1' }} /> Usted a finalizado con éxito la inscripción </p>
                                                            :
                                                            <div style={{ fontFamily: 'sans-serif', textAlign: 'left' }}>
                                                                <p style={{ border: "2px double #1C6EA4", borderRadius: '10px 10px 10px 10px', width: "100%", padding: 20 }}>
                                                                    <h5><span>Formulario PAC: </span></h5>
                                                                    <p style={{ fontSize: 19, marginTop: 18, marginLeft: 31 }}>Datos titular de la cuenta</p>
                                                                    <br />
                                                                    <Grid container item xs={12} sm={12} md={12} direction="column" justifyContent="center" alignItems="stretch">
                                                                        <Card elevation={0}>
                                                                            <CardContent>
                                                                                <Grid container direction="row" justifyContent="center" alignItems="stretch"  >
                                                                                    <Grid item xs={12} sm={5} md={5}>
                                                                                        <div className="form-group">
                                                                                            <label htmlFor="firstnameinsured">Rut <span className="required">*</span></label>
                                                                                            <input id="firstnameinsured"
                                                                                                disabled={guardado}
                                                                                                className={estiloRut}
                                                                                                name="firstname"
                                                                                                maxLength={13}
                                                                                                placeholder={'99.999.999-9'}
                                                                                                type="text"
                                                                                                onChange={(e: any) => { setRutCompletoPAC(formatterRut(e.target.value.trim())) }}
                                                                                                value={rutCompletoPAC}
                                                                                            />
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label htmlFor="firstnameinsured">Nombre<span className="required">*</span></label>
                                                                                            <input id="firstnameinsured"
                                                                                                name="firstname"
                                                                                                disabled={guardado}
                                                                                                /* style={{ width: '40%' }} */
                                                                                                className="form-control js-will-validate"
                                                                                                type="text"
                                                                                                onChange={(e: any) => { setNombresPAC(e.target.value) }}
                                                                                                value={nombresPAC}
                                                                                            />
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label htmlFor="firstnameinsured">Primer Apellido <span className="required">*</span></label>
                                                                                            <input id="firstnameinsured"
                                                                                                name="firstname"
                                                                                                disabled={guardado}
                                                                                                className="form-control js-will-validate"
                                                                                                type="text"
                                                                                                onChange={(e: any) => { setPrimerApellidoPAC(e.target.value) }}
                                                                                                value={primerApellidoPAC}
                                                                                            />
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label htmlFor="firstnameinsured">Segundo Apellido <span className="required">*</span></label>
                                                                                            <input id="firstnameinsured"
                                                                                                name="firstname"
                                                                                                disabled={guardado}
                                                                                                className="form-control js-will-validate"
                                                                                                type="text"
                                                                                                onChange={(e: any) => { setSegundoApellidoPAC(e.target.value) }}
                                                                                                value={segundoApellidoPAC}
                                                                                            />
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label htmlFor="firstnameinsured">Dirección <span className="required">*</span></label>
                                                                                            <input id="firstnameinsured"
                                                                                                name="firstname"
                                                                                                disabled={guardado}
                                                                                                className="form-control js-will-validate"
                                                                                                type="text"
                                                                                                onChange={(e: any) => { setDireccionPAC(e.target.value) }}
                                                                                                value={direccionPAC}
                                                                                            />
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label htmlFor="mobile-phoneinsured">Teléfono <span className="required">*</span></label>
                                                                                            <div className="personal-information__phones">
                                                                                                <span>+56</span>
                                                                                                <input id="mobile-phoneinsured"
                                                                                                    name="mobile-phone"
                                                                                                    disabled={guardado}
                                                                                                    className="form-control js-mobile js-will-validate"
                                                                                                    type="text"
                                                                                                    pattern="[0-9]*"
                                                                                                    maxLength={9}
                                                                                                    max={9}
                                                                                                    value={telefonoPAC}
                                                                                                    onChange={(e: any) => setTelefonoPAC(e.target.value)}
                                                                                                    onKeyPress={(event) => {
                                                                                                        if (!/[0-9]/.test(event.key)) {
                                                                                                            event.preventDefault();
                                                                                                        }
                                                                                                    }} />
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label htmlFor="firstnameinsured">Email<span className="required">*</span></label>
                                                                                            <input id="firstnameinsured"
                                                                                                name="firstname"
                                                                                                disabled={guardado}
                                                                                                /* style={{ width: '40%' }} */
                                                                                                className="form-control js-will-validate"
                                                                                                type="email"
                                                                                                onChange={(e: any) => setCorreoPAC(e.target.value)}
                                                                                                value={correoPAC}
                                                                                            />
                                                                                        </div>
                                                                                    </Grid>
                                                                                    <Grid item sm={1} md={1}>
                                                                                    </Grid>
                                                                                    <Grid item xs={12} sm={5} md={5}>
                                                                                        <div className="form-group">
                                                                                            <label htmlFor="firstnameinsured">Carrera <span className="required">*</span></label>
                                                                                            <input id="firstnameinsured"
                                                                                                name="firstname"
                                                                                                disabled={true}
                                                                                                className="form-control js-will-validate"
                                                                                                type="text"
                                                                                                onChange={(e: any) => { }}
                                                                                                value={/* idCarreraPAC */nombreCarreraPAC}
                                                                                            />
                                                                                        </div>
                                                                                        <div className="form-group form-group--genero">
                                                                                            <p>Banco <span className="required">*</span></p>
                                                                                            <Autocomplete
                                                                                                style={{ marginTop: -25, marginBottom: -10 }}
                                                                                                id="listaBancos"
                                                                                                value={valBancoPAC}
                                                                                                options={bancos}
                                                                                                disabled={guardado}
                                                                                                noOptionsText={'No existe la opción.'}
                                                                                                size='small'
                                                                                                getOptionLabel={(options: IViewCombo) => toUpperCamelCase(options.descripcion)}
                                                                                                onChange={handleSelectBanco}
                                                                                                renderInput={params => (
                                                                                                    <TextField
                                                                                                        {...params}
                                                                                                        variant='outlined'
                                                                                                        placeholder="Seleccione Banco"
                                                                                                        margin="normal"
                                                                                                        fullWidth
                                                                                                        inputProps={{
                                                                                                            ...params.inputProps,
                                                                                                            autoComplete: 'new-password',
                                                                                                        }}
                                                                                                    />
                                                                                                )}
                                                                                            />
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label htmlFor="firstnameinsured">N° Cuenta <span className="required">*</span></label>
                                                                                            <input id="firstnameinsured"
                                                                                                name="firstname"
                                                                                                disabled={guardado}
                                                                                                className="form-control js-will-validate"
                                                                                                type="number"
                                                                                                onChange={(e: any) => setNumCuentaPAC(e.target.value)}
                                                                                                value={numCuentaPAC}
                                                                                            />
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label htmlFor="firstnameinsured">Día cargo <span className="required">*</span></label>
                                                                                            <input id="firstnameinsured"
                                                                                                name="firstname"
                                                                                                style={{ width: '40%' }}
                                                                                                className="form-control js-will-validate"
                                                                                                type="number"
                                                                                                value={diaCargoPAC}
                                                                                                disabled={true}
                                                                                            />
                                                                                        </div>
                                                                                        <div className="form-group">
                                                                                            <label htmlFor="firstnameinsured">Observación</label>
                                                                                            {/* <input id="firstnameinsured"
                                                                            name="firstname"
                                                                            className="form-control js-will-validate"
                                                                            type="number"
                                                                            onChange={(e: any) => { }}
                                                                            value={""}
                                                                        /> */}
                                                                                            <textarea
                                                                                                disabled={guardado}
                                                                                                rows={5}
                                                                                                style={{ width: '100%', border: '1px solid #e6e6e6' }}
                                                                                                onChange={(e: any) => setObservacionPAC(e.target.value)}
                                                                                                value={observacionPAC}
                                                                                            >

                                                                                            </textarea>
                                                                                        </div>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </CardContent>
                                                                        </Card>
                                                                    </Grid>
                                                                    <br />
                                                                    {
                                                                        errorVal === "true" ?
                                                                            <Alert /* style={{ width: '20rem' }} */ variant="outlined" severity="warning">{mnsjError}</Alert>
                                                                            :
                                                                            ""
                                                                    }
                                                                    {
                                                                        resultPAC === "true" ?
                                                                            <Alert /* style={{ width: '20rem' }} */ variant="outlined" severity="warning">{"Ocurrió un problema al intentar guardar su información, favor intente mas tarde."}</Alert>
                                                                            :
                                                                            ""
                                                                    }
                                                                    <br /><br /><br />
                                                                    <div style={{ float: 'right', marginTop: -40 }}>
                                                                        <Button variant="contained" style={{ fontSize: 14, backgroundColor: '#0062a1', color: 'White' }} onClick={() => { handleValidarDatos() }}>Enviar</Button>
                                                                    </div>

                                                                </p>
                                                            </div>
                                                    :

                                                    listo ?
                                                        <p><CheckCircleOutline style={{ fontSize: 50, color: '#0062a1' }} /> Usted ya tiene este proceso listo.</p>
                                                        :
                                                        resultPAT ?
                                                            <p><CheckCircleOutline style={{ fontSize: 50, color: '#0062a1' }} /> Usted a finalizado con éxito la inscripción.</p>
                                                            :
                                                            <div className="payment-webpay__action">
                                                                <input
                                                                    type="submit"
                                                                    className="btn btn-success"
                                                                    onClick={() => {
                                                                        IniciarMandato()
                                                                    }}
                                                                    id="btn-pay-enrollment"
                                                                    value="Inscribirse en Patpass Comercio"
                                                                />
                                                            </div>
                                            }
                                            {
                                                errorPAT ?
                                                    <Alert style={{ marginTop: 10 }} variant="outlined" severity="error">{"Ocurrió un problema al intentar generar el formulario PAT."}</Alert>
                                                    :
                                                    ""
                                            }

                                            {
                                                resultPAC == "true" || tieneMandatoPAC ?
                                                    <>
                                                        <p style={{ border: '2px solid #cccf22', padding: '10px', textAlign: 'left', color: 'rgb(71 132 171)' }}>
                                                            <p>El mandato PAC debe ser entregado de forma física junto a la copia de la cedula de identidad del titular de la cuenta en:</p>
                                                            <div>
                                                                <Grid container item xs={12} sm={12} md={12} direction="column" >
                                                                    <Card elevation={0}>
                                                                        <CardContent>
                                                                            <Grid container direction="row"  >
                                                                                <Grid item xs={12} sm={5} md={5} direction="column">
                                                                                    <div style={{ /* border: '1px solid #cccf22', */ padding: 10, color: 'rgb(71 132 171)' }}>
                                                                                        <br></br>
                                                                                        <p style={{ textAlign: 'center' }}><u>SEDE SANTIAGO</u></p>
                                                                                        <br></br>
                                                                                        <p style={{ marginLeft: 40 }}>• Entregar en Oficinas de Matrícula</p>
                                                                                        <p style={{ marginLeft: 40 }}>• Av. Plaza # 680, Las Condes, Santiago</p>
                                                                                        <p style={{ marginLeft: 40 }}>&nbsp;&nbsp;&nbsp;</p>
                                                                                    </div>
                                                                                </Grid>
                                                                                <Grid item sm={1} md={1} direction="column">
                                                                                    <p></p>
                                                                                    <br></br>
                                                                                    <p></p>
                                                                                    <p></p>
                                                                                    <p></p>
                                                                                </Grid>
                                                                                <Grid item xs={1} sm={1} md={1} direction="column">
                                                                                    <div className="enrollment-header__hide2" style={{ borderLeft: '1px solid #cccf22', padding: 10 }}>
                                                                                        <p>&nbsp;</p>
                                                                                        <br></br>
                                                                                        <p>&nbsp;</p>
                                                                                        <p>&nbsp;</p>
                                                                                        <br></br>
                                                                                    </div>
                                                                                </Grid>
                                                                                <Grid item xs={12} sm={5} md={5} direction="column" >
                                                                                    <div style={{ /* border: '1px solid #cccf22', */ padding: 10, color: 'rgb(71 132 171)' }}>
                                                                                        <br></br>
                                                                                        <p style={{ textAlign: 'center' }}><u>SEDE CONCEPCIÓN</u></p>
                                                                                        <br></br>
                                                                                        <p style={{ marginLeft: 40 }}>• Entregar en Oficinas de Matrícula</p>
                                                                                        <p style={{ marginLeft: 40 }}>• Ainavillo 456, Concepción.</p>
                                                                                        <p style={{ marginLeft: 40 }}>&nbsp;&nbsp;&nbsp;</p>
                                                                                    </div>
                                                                                </Grid>
                                                                            </Grid>
                                                                        </CardContent>
                                                                    </Card>
                                                                </Grid>
                                                            </div>
                                                            <p style={{ marginTop: -30, paddingLeft: 40, paddingRight: 40 }}>NOTA: El mandato PAC tiene un periodo de activación de hasta 90 días, por este motivo se recomienda
                                                                pagar las primeras cuotas en el portal de pagos UDD <a href="https://udd.e-pagos.cl/uddPP/"><b>(https://udd.e-pagos.cl/uddPP/)</b></a>, ingresando con
                                                                el RUT del alumno y la clave son los primeros 8 números del RUT del alumno..</p>
                                                        </p>
                                                        <Button variant="contained" disabled={downloadComprobante} style={{ fontSize: 14, backgroundColor: '#0062a1', color: 'White' }} onClick={() => { obtenerComprobante() }}>{downloadComprobante ? <CircularProgress color="inherit" size={20} disableShrink /> : "Obtener comprobante mandato"}</Button>
                                                    </>
                                                    :
                                                    ""
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </main>
                        <Dialog open={openModalRespuesta}
                            onClose={() => setOpenModalRespuesta(false)}
                            maxWidth={"xl"}
                            aria-labelledby="draggable-dialog-title">
                            <DialogContent>
                                <div style={{ fontFamily: 'sans-serif', textAlign: 'center', height: '100%' }}>
                                    {
                                        resultPAT ?
                                            ""
                                            :
                                            <div style={{ textAlign: 'center', padding: 20 }}>
                                                <ErrorOutlineRounded style={{ fontSize: 100, color: 'red' }} />
                                                <br />
                                                <h3><span>Hemos tenido problemas al validar tu inscripción Patpass comercio.</span></h3>
                                                <br />
                                            </div>
                                    }

                                </div>
                            </DialogContent>
                            <DialogActions>
                                <Button autoFocus onClick={() => {
                                    setOpenModalRespuesta(false)
                                }} color="primary" >Salir</Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog open={procesoIniciado}
                            maxWidth={"xl"}
                            aria-labelledby="draggable-dialog-title">
                            <DialogContent>
                                <div style={{ fontFamily: 'sans-serif', textAlign: 'center' }}>
                                    {
                                        <div style={{ textAlign: 'center', padding: 20 }}>
                                            <CircularProgress disableShrink />
                                            <br />
                                            <br />
                                            <h4><span>Realizando inscripción Patpass comercio.</span></h4>
                                            <br />
                                        </div>
                                    }
                                </div>
                            </DialogContent>
                        </Dialog>
                    </>
            }
            {
                openModalToken.open ?
                    <MensajeToken mnsj={openModalToken.mnsj} codNegocio={codnegocio}></MensajeToken>
                    :
                    ""
            }
        </>
    )
}
export default PacPat;
